import { isTokenExpired, logout } from '../utils/authUtils';

export function useAuth() {
  const token = localStorage.getItem('token');

  let user = null;
  try {
    user = JSON.parse(localStorage.getItem('user'));
  } catch {
    user = null;
  }

  if (!token || isTokenExpired(token)) {
    logout();
  }

  return {
    token,
    roles: user?.roles || [],
    permissions: user?.permissions || [],
    user,
  };
}
